// import { useState, useCallback } from "react";
// import { getData } from "../services/apiService";

// const useFetchIp = () => {
//   const [ip, setIP] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const fetchIp = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await getData(`/client-ip`);
//       if (response) {
//         setIP(response.ipAddress);
//       }
//     } catch (error) {
//       console.error("Failed to fetch IP:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   return { ip, loading, fetchIp };
// };

// export default useFetchIp;

import { useState, useEffect } from "react";
import axios from "axios";

const useFetchIp = () => {
  const [ip, setIp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIp = async () => {
      try {
        setLoading(true);
        const response = await axios.get("https://api.ipify.org?format=json");
        setIp(response.data.ip);
      } catch (err) {
        setError(err.message || "Failed to fetch IP");
      } finally {
        setLoading(false);
      }
    };

    fetchIp();
  }, []);

  return { ip, loading, error };
};

export default useFetchIp;

